export default __webpack_public_path__ + "static/media/covidWebsite.0b7bde00.png";